// Pages
import RouterView from '@/components/pages/RouterView/Router'

import Trial from '@/components/pages/Clinical/Trial'
import Trials from '@/components/pages/Clinical/Trials'
import AddTrial from '@/components/pages/Clinical/AddTrial'
import EditTrial from '@/components/pages/Clinical/EditTrial'
import TrialSurgeons from '@/components/pages/Clinical/TrialSurgeons'
import TrialProfile from '@/components/pages/Clinical/TrialProfile'
import TrialResponses from '@/components/pages/Clinical/TrialResponses'

export default {
  path: '/clinical',
  component: RouterView,
  meta: {requiresAuth: true},
  children: [
    {
      path: '',
      name: 'all-studies',
      component: Trials,
    },
    {
      path: 'add-study',
      component: AddTrial,
    },
    {
      path: 'search-surgeon',
      component: TrialSurgeons,
    },
    {
      path: ':id',
      component: RouterView,
      props: true,
      children: [
        {
          path: '',
          component: Trial,
          props: true,
          name: 'view-study'
        },
        {
          path: 'edit',
          component: EditTrial,
          props: true,
          name: 'edit-study'
        },
        {
          path: 'surgeons',
          component: RouterView,
          props: true,
          children: [
            {
              path: ':surgeonId/responses',
              name: 'view-surgeon-responses',
              component: TrialResponses,
            },
          ]
        },
      ]
    },
    {
      path: 'surgeons',
      component: RouterView,
      props: true,
      children: [
        {
          path: ':id/trials',
          component: TrialProfile,
          props: true,
          name: 'view-surgeon-trials',
        },
      ]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/clinical.js